import 'angular-material/angular-material.css'
import 'mdi/css/materialdesignicons.css'
import '../scss/style.scss'
import '../lib'
import { createApp } from './app.module'

export const app = createApp([
  'ui.router',
  'ngMaterial',
  'restangular',
  'ngCookies',
  'ngMessages',
  'ngCsv',
  'ngSanitize',
])
  .run(($state, $rootScope) => {
    // stateの情報をrootScopeにセット
    $rootScope.$state = $state
  })
  // stateの設定
  .config(($stateProvider, $urlRouterProvider) => {
    // どのルーティングにも該当しない場合はloginへリダイレクト
    $urlRouterProvider.otherwise('/login')

    // 各ページのstateを定義
    $stateProvider
      .state('login', {
        url: '/login',
        template: require('./login/login.pug')(),
        controller: 'LoginCtrl',
        title: 'ログイン',
        titleEng: 'Login',
      })
      .state('reset-password', {
        url: '/reset-password',
        template: require('./reset-password/reset-password.pug')(),
        controller: 'ResetPasswordCtrl',
        title: 'パスワード再設定',
        titleEng: 'Reset Password',
      })
  })
  // Angular Materialの設定
  .config(($mdThemingProvider) => {
    $mdThemingProvider
      .theme('default')
      .primaryPalette('indigo', {
        default: '400',
      })
      .accentPalette('lime', {
        default: '300',
        'hue-1': '100',
        'hue-2': '200',
      })
    // toasterのテーマ設定
    $mdThemingProvider.theme('success-toast')
    $mdThemingProvider.theme('error-toast')
  })
  // その他の設定
  .config(($locationProvider, $httpProvider) => {
    // html5Modeを有効に
    $locationProvider.html5Mode(true)

    // [IE対策] GETメソッド用のヘッダーを初期化
    if (!$httpProvider.defaults.headers.get) {
      $httpProvider.defaults.headers.get = {}
    }

    // [IE対策] Ajaxリクエストキャッシュを無効にする
    $httpProvider.defaults.headers.get['If-Modified-Since'] = '0'
  })
  // RestAngularの共通設定
  .config((RestangularProvider) => {
    // APIのベースURLを設定
    RestangularProvider.setBaseUrl('/api')
  })

import './app'
